module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyIDNIMkwxMCAxMi40NlYxOUwxNCAyMVYxMi40NkwyMiAzWiIgc3Ryb2tlPSIjMzg3NkQyIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/primary/filter.svg
// module id = 1072
// module chunks = 37